export default __webpack_public_path__ + "static/media/animal-43.1b46c38c.svg";